enum JobWorkerTabIndex {
	Browse = 0,
	Shortlisted = 1,
	Interested = 2,
	Interviewing = 3,
	Offers = 4,
	Placed = 5,
	Rejected = 6,

}

export default JobWorkerTabIndex;